// passing the path into variables

// const banner1 = '/assets/norte/Home/Ivergrama-Website-Home-MainBanner1.jpg';

const banner1 = '/assets/norte/Home/banner-one.webp';
const banner2 = '/assets/norte/Home/banner-two.webp';
const banner3 = '/assets/norte/Home/banner-three.webp';


const destination1 =
	'/assets/norte/Home/destinos-santiago.png';
const destination2 =
	'/assets/norte/Home/destinos-rancagua.png';
const destination3 =
	'/assets/norte/Home/destinos-osorno.png';

const destination4 =
	'/assets/norte/Home/destinos-valdivia.png';
const destination5 =
	'/assets/norte/Home/puerto-montt.png';

const destination6 =
	'/assets/norte/Home/destinos-union.png';

// const destination7 =
// '/assets/norte/Home/destinos-santiago.png';
// const destination8 =
// 	'/assets/norte/Home/destinos-santiago.png';

const service1 = '/assets/norte/Home/destinos-santiago.png';
const service2 = '/assets/norte/Home/destinos-rancagua.png';
const service3 = '/assets/norte/Home/puerto-montt.png';
const service4 = '/assets/norte/Home/destinos-osorno.png';
const service5 = '/assets/norte/Home/destinos-valdivia.png';
const service6 = '/assets/norte/Home/destinos-union.png';
const services = [service1, service2, service3, service4, service5, service6];

const gallery1 = '/assets/norte/Home/gallery1.png'
const gallery2 = '/assets/norte/Home/gallery2.png'
const gallery3 = '/assets/norte/Home/gallery3.png'
const gallery4 = '/assets/norte/Home/gallery4.png'
const gallery5 = '/assets/norte/Home/gallery5.png'
const gallery6 = '/assets/norte/Home/gallery6.png'
const gallery7 = '/assets/norte/Home/gallery7.png'
const gallery8 = '/assets/norte/Home/gallery8.png'
const gallery = [gallery1, gallery2, gallery3, gallery4,gallery5,gallery6,gallery7,gallery8]

const destination = [
	{ one: destination1, two: destination2, three: destination3, four: destination4, },

	{
		one: destination5,
		two: destination6,
		three: destination1,
		four: destination2,
	},
];


const banner = [banner1, banner2, banner3];


const busnorteSlides = {
	banner,
	destination,
	services,
	gallery
};

export default busnorteSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/busnorteSlides.js